import axios from "axios";
import { setAlert } from "./alert";
import { setErrorsList } from "./errors";
import { logout } from "./auth";
import { removeErrors } from "reducers/errors";

import {
  loadingOnProviderOigExclusionSubmit,
  providerOigExclusionError,
  providerOigExclusionUpdated,
  resetProviderOigExclusion,
} from "reducers/providerOigExclusionReducer";

export const getProviderOigExclusionById =
  (provider_id) => async (dispatch) => {
    dispatch(removeErrors());
    dispatch(loadingOnProviderOigExclusionSubmit());
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.get(
        `/api/admin/providers/${provider_id}/oig_exclusion`,
        config
      );

      dispatch(providerOigExclusionUpdated(res.data.response));
      return res.data ? res.data.response : { status: false };
    } catch (err) {
      console.log(err);
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        err.response &&
          dispatch(
            providerOigExclusionError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );

        dispatch(setAlert(err.response.message, "danger"));
      }
    }
  };

export const saveProviderOigExclusion =
  (formData, provider_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const res = await axios.post(
        `/api/admin/providers/${provider_id}/oig_exclusion/save`,
        formData,
        config
      );

      if (res.data.status === true) {
        await dispatch(providerOigExclusionUpdated(res.data.response));
        dispatch(setAlert(res.data.message, "success"));
        return res.data ? res.data : { status: false };
      } else {
        const errors = res.data.errors;
        dispatch(setAlert(res.data?.message, "danger"));

        if (errors.length) {
          dispatch(providerOigExclusionError());
          dispatch(setErrors(errors));
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch(
            providerOigExclusionError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

export const resetProviderOigExclusionComponentStore =
  () => async (dispatch) => {
    await dispatch(resetProviderOigExclusion());
  };

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch(providerOigExclusionError());
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

export const removeProviderOigExclusionErrors = () => async (dispatch) => {
  dispatch(removeErrors());
};
